module.exports = __webpack_public_path__ + "static/18624801_10213365279275356_183963331_n-21b72dd73f5a023f2c3008196767d846.jpg";